import { Link } from "expo-router";
import {
  Button,
  Layout,
  SurveyTransition as SurveyTransitionBase,
} from "@ptsd/uikit";
import { ArrowRight } from "@tamagui/lucide-icons";
import { useTranslation } from "react-i18next";
import { useMedia, View, XStack } from "tamagui";

import { api } from "~/utils/api";
import { Footer, Header, useLayoutScrollProps } from "~/component/layout";
import { useTrackOnce } from "~/hooks/use-track";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const image = require("../../../assets/onboarding/frame-1.png");

const SurveyTransition = () => {
  const { sm } = useMedia();

  const [task] = api.home.tasksStatus.useSuspenseQuery(undefined, {
    refetchOnMount: true,
  });
  const isDiagnosticRequested = task?.todo?.diagnostic === "requested";

  useTrackOnce("Render Survey Transition Page");

  const { t } = useTranslation("surveyTransition");

  const scrollProps = useLayoutScrollProps();

  return (
    <Layout variant="monobackground" scrollProps={scrollProps}>
      <Header isTutorial />
      <View
        alignSelf="center"
        flexDirection="row"
        maxWidth={1248}
        paddingHorizontal={"$3"}
        flex={2}
        width={"100%"}
        $sm={{
          flexDirection: "column-reverse",
          alignSelf: "flex-start",
          paddingTop: "$4",
          gap: "$2.5",
        }}
      >
        <View
          flex={1}
          width={"50%"}
          justifyContent="center"
          alignSelf="center"
          paddingRight={"$5.1"}
          $sm={{
            paddingRight: 0,
            width: "100%",
          }}
        >
          <View
            maxWidth={558}
            gap={"$10"}
            $sm={{
              width: "100%",
              maxWidth: 1000,
              gap: "$3",
            }}
          >
            <View
              gap={"$4"}
              $sm={{
                gap: "$2",
              }}
            >
              <View>
                <SurveyTransitionBase.Title>
                  {t("title")}
                </SurveyTransitionBase.Title>
              </View>

              <SurveyTransitionBase.Description>
                {t("desc")}
              </SurveyTransitionBase.Description>
            </View>

            <View
              gap={"$2"}
              $sm={{
                alignSelf: "center",
              }}
            >
              <XStack gap={"$1"}>
                <Link
                  data-id={"survey-transition-home-link"}
                  href={isDiagnosticRequested ? "/survey/diagnostic" : "/"}
                  asChild
                >
                  <Button
                    variant="primary"
                    size="lg"
                    rounded="lg"
                    iconAfter={<ArrowRight color={"white"} size={"$2.5"} />}
                    flex={1}
                    maxWidth={308}
                    {...(sm && {
                      size: "md",
                    })}
                  >
                    {isDiagnosticRequested ? t("buttonNext") : t("buttonHome")}
                  </Button>
                </Link>
              </XStack>
            </View>
          </View>
        </View>

        <View
          justifyContent="center"
          alignSelf="center"
          paddingLeft={"$5.1"}
          width={"50%"}
          flex={1}
          $sm={{
            paddingLeft: 0,
            maxWidth: 1000,
            width: "100%",
            alignItems: "center",
          }}
        >
          <SurveyTransitionBase.Image src={image} />
        </View>
      </View>

      {sm && (
        <View paddingTop={"$5"}>
          <Footer />
        </View>
      )}
    </Layout>
  );
};

export default SurveyTransition;
